// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileMenuModal_wrapper__TYO0P","logo":"MobileMenuModal_logo__dSDB6","userWrapper":"MobileMenuModal_userWrapper__o7rY5","email":"MobileMenuModal_email__wnXmF"};